
import { profileComputed } from "@/state/helpers";
import { authComputed } from "@/state/helpers";
import { KcmProfileField } from "@/types";
import { defineComponent } from "vue";

export default defineComponent({
  methods: {
    getStyle(textObject: KcmProfileField): string {
      let string = "font-size: " + textObject.fontSize + "px";
      return string;
    },
  },

  computed: {
    ...profileComputed,
    ...authComputed,

    phoneLink(): string {
      return "tel:" + this.profilePP.basic.phone.value;
    },

    emailLink(): string {
      return "mailto:" + this.profilePP.blog.lead_email.value;
    },
  },
});
